

























































































































































































































































































































































































































import _ from 'lodash';
import {
  defineComponent,
  ref,
  onUnmounted,
  toRefs,
  computed,
  getCurrentInstance,
  watch,
  ComponentInternalInstance,
  onMounted,
  nextTick,
} from '@vue/composition-api';
import { StarFilledIcon, EllipsisIcon, DownloadIcon, ShareIcon, FolderIcon, RefreshIcon } from 'tdesign-icons-vue';

// 引入组件
import AddFileAuth from '@/renderer/components/dialog/AddTransfer/AddFileAuth/index.vue';
import linkShare from '@/renderer/components/dialog/linkShare/index.vue';
import renameFolderDialog from '@/renderer/components/dialog/rename.vue';
import Menu from '@/renderer/components/Menu/Menu.vue';
import MenuItem from '@/renderer/components/Menu/MenuItem.vue';
import WemeetLinkShare from '@/renderer/components/dialog/linkShare/WemeetShare.vue';
import FileCollectResultDialog from '@/renderer/components/dialog/FileCollect/components/FileCollectResultDialog.vue';
import FileCollectFormDialog from '@/renderer/components/dialog/FileCollect/components/FileCollectFormDialog.vue';
import StatusTag from '@/renderer/components/SpacePage/components/StatusTag.vue';
import FileIcon from '@/renderer/components/Base/BaseTableFileIcon/FileIcon.vue';

import FileApplyDialog from '@/renderer/components/dialog/FileApply/components/FileApplyDialog.vue';
// 引入 compositions
import renameHandler from '@/renderer/components/SpacePage/compositions/renameHandler';
import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';
// eslint-disable-next-line import/no-cycle
import openPreviewHandler from '@/renderer/components/SpacePage/compositions/openPreviewHandler';
import linkShareHandler from '@/renderer/components/dialog/linkShare/composition/linkShareHandler';
import authHandler from '@/renderer/components/SpacePage/compositions/authHandler';
import extraFileInfoHandler from '@/renderer/components/SpacePage/compositions/extraFileInfoHandler';
import downloadHandler from '@/renderer/components/SpacePage/compositions/downloadHandler';
import deleteHandler from '@/renderer/components/SpacePage/compositions/deleteHandler';
import shareInWeMeetingHandler from '@/renderer/views/desktop/headbar/composition/shareInWeMeetingHandler';
import fileCollectDialogHandler from '@/renderer/components/dialog/FileCollect/composition/fileCollectDialogHandler';
import { fileLocationHandler } from '@/renderer/views/desktop/FileManagement/RelatedToMe/composition/fileLocationHandler';
import listOperateHandler from '@/renderer/scripts/composition/listOperateHandler';
import { actionHandler } from '@/renderer/components/SpacePage/compositions/actionHandler';
// 引入工具类
import i18n, { i18n_t } from '@/locales/i18n';
import { checkIfMobileStyle } from '@/renderer/scripts/composition/dialogHandler';
import { can, optAuth } from '@/renderer/scripts/composition/authHandler';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import storage from '@/renderer/scripts/utils/storage';
import ipc from '@/renderer/scripts/utils/ipc';
import {
  isAllowEditDoc,
  isAllowPreviewImage,
  isAllowPrivate,
  noPreview,
} from '@/renderer/scripts/composition/allowPreview';
import tips from '@/renderer/scripts/utils/tips';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
import { GetDropdownItemShortCutText } from '@/renderer/scripts/utils/hotkeyDataHelper';
import { SMH } from '@/renderer/scripts/libs/smh-sdk-class';
import { openFolderOrDirectory } from '@/renderer/scripts/utils/openFolderOrDirectory';
import favorListHandle from './favoriteListHandler';
import drawerHandler from '../composition/drawerHandler';
export default defineComponent({
  name: 'MyFavorite',
  components: {
    FileIcon,
    FileApplyDialog,
    StatusTag,
    linkShare,
    WemeetLinkShare,
    AddFileAuth,
    StarFilledIcon,
    renameFolderDialog,
    Menu,
    MenuItem,
    RefreshIcon,
    EllipsisIcon,
    DownloadIcon,
    ShareIcon,
    FolderIcon,
    FileCollectResultDialog,
    FileCollectFormDialog,
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    isSilentRefreshing: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent?.proxy || context.root;
    const router = vm.$router;
    const store = vm.$store;
    const { name } = router.currentRoute;
    const canCopyMove = ref(name !== 'relatedToMeFileList');
    const spaceId = ref('');
    const spaceOrgId = ref(-1);
    const selectItem = ref({});
    const requestPermissionVisible = ref(false);
    const departmentList = computed(() => tableData.selectedList[0]?.path || []);
    const noDisableRoleSelect = computed(() => tableData.selectedList[0]?.spaceTag === 'personal');
    const { filterMethods, comboMethods } = actionHandler();
    const { show: showAuth, authParams, teamId: authTeamId, methods: authMethods } = authHandler(spaceId);
    const { methods: downloadMethods } = downloadHandler(spaceId);
    const {
      columns,
      pageData,
      tableData,
      loading: loadingList,
      loadingOnHeader,
      sort,
      methods: listMethods,
    } = favorListHandle();
    const {
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      hoverIndex,
      isDropdownShow,
      methods: listOperateMethods,
    } = listOperateHandler(tableData);
    const resizeColumns = computed<any[]>(() => {
      const checkboxColumn = {
        colKey: 'row-select',
        type: 'multiple',
        width: 20,
      };
      if (props.showCheckbox) {
        return [checkboxColumn, ...columns.value];
      }
      return setResizableColumns(columns.value);
    });
    const currentUser = computed(() => store.getters.userBaseInfo);
    const { methods: fileLocationMethods } = fileLocationHandler();
    const { methods: extraFileInfoMethods } = extraFileInfoHandler(spaceId);
    const {
      show: showLink,
      showWemeetShare,
      linkData,
      viewData,
      methods: linkShareMethods,
    } = linkShareHandler(spaceId);
    const { methods: deleteMethods } = deleteHandler(spaceId, true);
    const {
      show: showRename,
      originName: fromName,
      type: renameType,
      methods: renameMethods,
      renameError,
    } = renameHandler(spaceId, true);
    const { methods: previewMethods } = openPreviewHandler(spaceId, spaceOrgId);
    const hasUnvisible = computed(() => tableData.selectedList.some((item: any) => !item.visible));
    const { methods: wemeetingMethods } = shareInWeMeetingHandler();
    const { fileColleDialogMethods, fileCollectDialog } = fileCollectDialogHandler();
    const focusList = () => {
      const { filePageRef }: any = (currComponent as ComponentInternalInstance).refs;
      filePageRef.focus({
        preventScroll: true,
      });
    };

    const methods = {
      async onOperateEventProxy(command: string, item: any, btnLocation?: string) {
        reporter.report('file_actions', {
          command,
          file_name: item?.name || '',
          space_module: 'myFavorite',
          department_name: 'myFavorite',
        });
        if (item) {
          spaceId.value = item.spaceId;
          spaceOrgId.value = item.spaceOrgId;
        }
        switch (command) {
          case 'delFavorite':
            {
              const favorIds = item ? [item.favoriteId || item.id] : tableData.selectedRowKeys;
              extraFileInfoMethods.delFavorite(favorIds, tableData.list, spaceOrgId.value);
            }
            break;
          case 'allFailure':
            {
              const favorIds: number[] = [];
              tableData.list.forEach(item => {
                // 不可见的文件被删除了，访问额外信息的时候后端不回返回，这里直接拿 item.id 即是收藏的 id
                !item.visible && favorIds.push(item.id);
              });
              if (favorIds.length === 0) {
                tips.info(i18n_t('无失效的收藏文件'));
                return;
              }
              extraFileInfoMethods.delFavorite(favorIds, tableData.list, spaceOrgId.value, 'allFailure');
            }
            break;
          case 'auth':
            {
              if (checkIfMobileStyle()) return;
              const params = {
                userId: item.userId,
                virusAuditStatus: item.virusAuditStatus,
                path: item.path.join('/'),
                spaceTag: item.spaceTag,
                teamId: item.team?.id,
              };
              const canOpenAuthDialog = authMethods.canOpenAuthDir(params);
              if (!canOpenAuthDialog) return;
              Object.assign(authParams, { params });
              showAuth.value = true;
            }
            break;
          case 'share':
            {
              const shareData = item ? [item] : tableData.selectedList;
              if (store.getters.isInWeMeetApp) {
                const { preview, edit } = methods.getFileOrDirPermission(shareData[0]);
                shareData[0] = {
                  ...item,
                  canPreview: preview,
                  canEdit: edit,
                };
              }
              linkShareMethods.openShare(shareData);
            }
            break;
          case 'download':
            {
              const downloadData = item ? [item] : tableData.selectedList;
              downloadMethods.prepareDownload(downloadData);
              reporter.report('download', {
                download_location: 'myFavorite',
                download_mode: 'single_download',
                batch_num: 1,
                downloadData,
                file_name: item?.name || '',
              });
            }
            break;
          case 'detail':
          case 'history':
            tableData.selectedRowKeys = [item.id];
            tableData.selectedList = [item];
            ipc.emit(ipc.RENDERER_EVENTS_MAP.COMMAND_SHOW_DETAIL, command);
            break;
          case 'openFolder':
            if (!item.visible) return;
            if (item.type === 'dir') {
              openFolderOrDirectory({ item, isOpenFolder: true, targetRouteName: 'favoriteList' });
            } else if (noPreview(item)) {
              tips.error(i18n_t('该格式暂不支持预览'));
            } else if (!item.authorityList?.canPreview) {
              tips.error(i18n_t('暂无预览权限，请联系管理员'));
            } else if (isAllowPreviewImage(item.name) && item.size >= ConstantConfig.ciImageMaxSize) {
              // 万象最大支持32mb
              tips.error(i18n_t('文件过大，请下载至本地查看'));
            } else if (!store.getters.enableDocPreview && !isAllowPrivate(item.name)) {
              if (isAllowEditDoc(item.name)) {
                tips.error(i18n_t('当前文件暂未接入文档预览与编辑服务，请下载至本地查看'));
              } else {
                tips.error(i18n_t('该文件暂不支持预览，请下载至本地查看'));
              }
            } else {
              previewMethods.openPreview(item, 1);
            }
            break;
          case 'rename':
            renameMethods.openRenameFolder(item);
            break;
          case 'edit':
            if (!item.authorityList?.canModify) {
              tips.error(i18n_t('暂无权限，请联系管理员'));
            } else {
              previewMethods.openEdit(item);
            }
            break;
          case 'preview':
            if (isAllowPreviewImage(item.name) && item.size >= ConstantConfig.ciImageMaxSize) {
              // 万象最大支持32mb
              tips.error(i18n_t('文件过大，请下载至本地查看'));
            } else if (!store.getters.enableDocPreview && !isAllowPrivate(item.name)) {
              if (isAllowEditDoc(item.name)) {
                tips.error(i18n_t('当前文件暂未接入文档预览与编辑服务，请下载至本地查看'));
              } else {
                tips.error(i18n_t('该文件暂不支持预览，请下载至本地查看'));
              }
            } else {
              previewMethods.openPreview(item, 1);
            }
            break;
          case 'delete':
            deleteMethods.confirmDelete([item], false, focusList);
            reporter.report('delete', {
              delete_location: vm.$route.name,
            });
            break;
          case 'invite_to_preview':
          case 'invite_to_edit': {
            const selectedItem = item || tableData.selectedList[0];
            const [, , action] = command.split('_');
            wemeetingMethods.share(action, {
              ...selectedItem,
              spaceId: spaceId.value,
              btnLocation,
            });
            break;
          }
          case 'openOriginDirectroy':
            {
              openFolderOrDirectory({ item, isOpenFolder: false });
            }
            break;
          case 'esign': {
            previewMethods.openPreview(item, 1, {
              esign: true,
            });
            break;
          }
          case 'fileCollect':
            if (checkIfMobileStyle()) return;
            fileColleDialogMethods.openFileCollectFormDialog([item]);
            reporter.report('task_start', {
              start_way: 'folder',
            });
            break;
          case 'requestPermission':
            requestPermissionVisible.value = true;
            break;
          default:
            break;
        }
      },
      getFileOrDirPermission(item: SMH.FavoriteFileItemData): Record<string, boolean> {
        let actionMap = comboMethods.getFileOrDirPermission([item], true);
        actionMap = filterMethods.filterAll(actionMap, item);
        return actionMap;
      },
      renderDropdownItemOptions(item: any) {
        const map: Record<string, string> = {
          // 腾讯会议中此2入口放最上
          invite_to_preview: i18n_t('邀请预览'),
          invite_to_edit: i18n_t('邀请编辑'),
          detail: i18n_t('详情'),
          download: i18n_t('下载'),
          preview: i18n_t('在线预览'),
          edit: i18n_t('在线编辑'),
          esign: i18n_t('发起电子签'),
          rename: i18n_t('重命名'),
          delFavorite: i18n_t('取消收藏'),
          fileCollect: i18n_t('发起文件收集'),
          requestPermission: i18n_t('权限申请'),
          auth: i18n_t('添加共享成员'),
          history: i18n_t('历史版本'),
          delete: i18n_t('删除'),
        };
        const allow: Record<string, boolean> = methods.getFileOrDirPermission(item);
        const options: Array<{
          content: string;
          value: string;
        }> = [];
        Object.keys(map).forEach(key => {
          if (allow[key]) {
            options.push({
              content: map[key],
              value: key,
            });
          }
        });
        return options;
      },
      renderRowClass(params: any) {
        if (props.showCheckbox) return '';
        const className = [];
        // 是否选中
        return tableData.selectedRowKeys.join(',').includes(params?.row.id.toString()) ? 'is-selected' : '';
      },
      silentRefresh() {
        listMethods.silentRefresh();
      },
    };
    watch(
      () => [showWemeetShare.value, showAuth.value, showRename.value, showLink.value],
      () => {
        if (!showWemeetShare.value && !showAuth.value && !showRename.value && !showLink.value) {
          focusList();
        }
      },
    );
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.FAVOR_LIST_FRESH, listMethods.clearSelectedAndPullList);
      nextTick(() => {
        focusList();
      });
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.FAVOR_LIST_FRESH, listMethods.clearSelectedAndPullList);
    });
    if (vm.$route.name === 'myFavorite') {
      // 我的收藏单独路由页需要自行初始化抽屉
      drawerHandler();
    }
    const handleHotKeyAction = (action: string): boolean => {
      // 过滤t-dialog弹窗打开的情况
      if (
        loadingList.value ||
        tableData.selectedRowKeys.length <= 0 ||
        (!tableData.selectedList[0].visible && action !== 'addFavorite' && action !== 'delFavorite') ||
        [...document.getElementsByClassName('t-dialog__ctx')].filter(e => (e as HTMLElement).style.display !== 'none')
          .length > 0
      ) {
        return false;
      }
      const allow: Record<string, boolean> = methods.getFileOrDirPermission(tableData.selectedList[0]);
      switch (action) {
        case 'rename':
          if (allow.rename) {
            methods.onOperateEventProxy(action, tableData.selectedList[0]);
            return true;
          }
          break;
        case 'openFolder':
          methods.onOperateEventProxy(action, tableData.selectedList[0]);
          return true;
        case 'download':
          if (optAuth('Download', tableData.selectedList[0] as any)) {
            methods.onOperateEventProxy(action, tableData.selectedList[0]);
            return true;
          }
          break;
        case 'share':
          if (allow.share) {
            methods.onOperateEventProxy(action, tableData.selectedList[0]);
            return true;
          }
          break;
        case 'addFavorite':
        case 'delFavorite':
          if (tableData.selectedRowKeys.length === 1 && allow.delFavorite) {
            methods.onOperateEventProxy('delFavorite', tableData.selectedList[0]);
            return true;
          }
          break;
        case 'delete':
          if (allow.delete) {
            methods.onOperateEventProxy(action, tableData.selectedList[0]);
            return true;
          }
          return true;
        default:
          break;
      }
      return false;
    };
    return {
      departmentList,
      can,
      currentUser,
      resizeColumns,
      sort,
      loadingList,
      loadingOnHeader,
      pageData,
      noDisableRoleSelect,
      operateShowMap,
      isDropdownShow,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      hoverIndex,
      listOperateMethods,
      ...toRefs(tableData),
      ...toRefs(pageData),
      ...methods,
      listMethods,
      requestPermissionVisible,
      showLink,
      showWemeetShare,
      linkData,
      viewData,
      linkShareMethods,
      showAuth,
      authTeamId,
      authParams,
      authMethods,
      selectItem,
      spaceId,
      canCopyMove,
      showRename,
      fromName,
      renameType,
      renameError,
      renameMethods,
      hasUnvisible,
      optAuth,
      handleHotKeyAction,
      fileColleDialogMethods,
      fileCollectDialog,
      GetDropdownItemShortCutText,
    };
  },
});
